export default '/pricing/resume';
